import script from "./StudentGrowth.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentGrowth.vue?vue&type=script&setup=true&lang=js"

import "./StudentGrowth.vue?vue&type=style&index=0&id=4e26a7b5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e26a7b5"]])

export default __exports__